<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations" style="margin-top: 5px">
          <div class="filters">
            <el-form
              :inline="true"
              label-width="60px"
              label-position="left"
              @submit.native.prevent="filter.pageNum=1;toQuery()"
            >
              <el-form-item label="UN No.">
                <el-input v-model="filter.unNo" />
              </el-form-item>
              <el-form-item label="Class">
                <el-input v-model="filter.classification" />
              </el-form-item>
            </el-form>
            <div>
              <el-button type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
              <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
              <el-button type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
              <el-button type="danger" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
              <el-upload
                ref="upload"
                :action="actionUrl"
                :headers="{sessionId}"
                :show-file-list="false"
                accept=".txt"
                :before-upload="beforeUpload"
                :on-success="uploadSuccess"
                style="display: inline-block;margin: 0 5px"
              >
                <el-button type="primary">{{ $t('Information.IMDGCODEImport') }}</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="total>0"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <!--新增/编辑 弹窗-->
    <form-dialog
      :visible.sync="formDialog.visible"
      :is-edit="formDialog.isEdit"
      :uuid="formDialog.uuid"
      @saveCallBack="toQuery"
      @close="formDialog.visible=false"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as imdgCodeApi from '@/api/sysManage/imdgCode'
import formDialog from '@/views/cargo/v0/Information/components/dangerousGoods/formDialog'
import URL from '@/api/urlTranslator'
import { exportExcel } from '@/utils/tableDataExportUtils'

export default {
  name: 'SmDangerousGoods',
  components: { formDialog },
  data() {
    return {
      filter: {
        unNo: '',
        classification: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      girdParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        },
        suppressContextMenu: false, // 右键列表弹出菜单
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '', checkboxSelection: true, width: 55,
          sortable: false, suppressMenu: true, suppressSizeToFit: true,
          resizable: false, headerCheckboxSelection: true
        },
        {
          headerName: 'UN No.',
          field: 'unNo',
          width: 200
        },
        {
          headerName: 'PSN',
          field: 'psn',
          width: 200
        },
        {
          headerName: 'Class',
          field: 'classification',
          width: 200
        },
        {
          headerName: 'Packing Group',
          field: 'packingGroup',
          width: 200
        },
        {
          headerName: 'Limited Quantities',
          field: 'limitedQuantities',
          width: 200
        },
        {
          headerName: 'Excepted Quantities',
          field: 'exceptedQuantities',
          width: 200
        }
      ],
      rowData: [],
      addDialogVisible: false,
      formDialog: {
        visible: false,
        isEdit: false,
        uuid: ''
      }
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    },
    actionUrl() {
      return URL.sys.importFromTxtFile + '?sessionId=' + this.$store.getters.token + '&currentBranchId=' + this.$store.getters.currentOfficeId
    }
  },
  watch: {},
  methods: {
    onShow() {
      this.toQuery()
    },
    toQuery() {
      const params = { ...this.filter }
      const loading = getLoading()
      imdgCodeApi.queryIMDGCodes(params).then(resp => {
        this.rowData = resp.data.list
        this.filter.pageNum = resp.data.pageNum
        this.filter.pageSize = resp.data.pageSize
        this.total = Number(resp.data.total)
      }).finally(() => loading.close())
    },
    addHandler() {
      this.formDialog.isEdit = false
      this.formDialog.uuid = ''
      this.formDialog.visible = true
    },
    editHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const selectedRow = cell ? this.rowData[cell.rowIndex] : null
      if (!selectedRow) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      }
      this.formDialog.isEdit = true
      this.formDialog.uuid = selectedRow.uuid
      this.formDialog.visible = true
    },
    removeHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ISWBDC').replace('{0}', selectedRows.length), this.$t('Message.Prompt'), { closeOnClickModal: false }).then(() => {
        const uuids = selectedRows.map(row => row.uuid)
        const loading = getLoading()
        imdgCodeApi.removeIMDGCodes(uuids).then(() => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.toQuery()
        }).finally(() => loading.close())
      })
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileType !== 'txt') {
        this.$message.warning(this.$t('Information.PleaseUploadTxtFormatFile'))
        return false
      }
      return true
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        const count = response.data
        let msg = ''
        if (count > 0) {
          msg += this.$t('Information.SuccessfullyImported') + count + this.$t('Information.Items3')
        }
        this.$message.success(msg)
      } else {
        this.$message.warning(this.$t('Information.ImportPleaseContactTheAdministrator'))
      }
      // 刷新页面
      this.toQuery()
    },
    exportExcelHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('Information.DangerousGoodsList'), this.rowData, columnDefs)
    }
  }
}
</script>

<style scoped>

</style>
